import React from "react";
import { Document, Page, StyleSheet } from "@react-pdf/renderer";
import PropTypes from "prop-types";
import { SingleDayColumn } from "./SingleDayColumn";
import { SingleDayActivityTypeColumns } from "./SingleDayActivityTypeColumns";
import { SingleDayProductRows } from "./SingleDayProductRows";

const PdfStockSingleDay = props => {
  const { stocksProduct, selectedDate } = props;
  
  return (
    <Document>
      {stocksProduct.printData.map((category, catKey) => (
        <Page
          wrap
          size="A4"
          style={styles.page}
          orientation="portrait"
          key={catKey}
        >
          <SingleDayColumn
            selectedDate={selectedDate}
            styles={styles}
            key={catKey + 10000}
          />
          <SingleDayActivityTypeColumns
            categoryName={category.name}
            styles={styles}
            key={catKey + 20000}
          />
          <SingleDayProductRows
            category={category}
            styles={styles}
            key={catKey + 30000}
          />
        </Page>
      ))}
    </Document>
  );
};

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  noBorder: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "0 0",
    width: "100%",
  },
  noBorderAlternate: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "0 0",
    width: "100%",
    backgroundColor: "#f5f5f5"
  },
  border: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    borderTop: "1 solid black",
    padding: "0 0",
    width: "100%",
  },
  borderAlternate: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    borderTop: "1 solid black",
    padding: "0 0",
    width: "100%",
    backgroundColor: "#f5f5f5"
  },
  borderType: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "0 0",
    backgroundColor: "black",
    color: "white",
    width: "100%"
  },
  title: {
    width: "100%"
  },
  singleDay: {
    width: "64%",
    textAlign: "center",
    borderRight: "1 solid black",
    borderLeft: "1 solid black"
  },
  type: {
    width: "8%",
    textAlign: "center",
    borderRight: "1 solid white"
  },
  product: {
    width: "36%",
    borderRight: "1 solid black",
  },
  stock: {
    width: "8%",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingBottom: 3,
    paddingTop: 3,
    paddingRight: 0,
    paddingLeft: 0,
  },
  titleText: {
    fontSize: 14,
    textAlign: "center",
    paddingBottom: 5,
    fontStyle: "italic"
  },
  text: {
    fontSize: 10
  },
  textTotal: {
    fontSize: 10,
    color: "red",
    textDecoration: "underline"
  },
  textType: {
    fontSize: 8
  },
  staticCell13: {
    width: "5%",
    borderRight: "1 solid black",
    borderTop: "1 solid black",
    textAlign: "left",
    paddingBottom: 5,
    paddingTop: 5,
    paddingRight: 0,
    paddingLeft: 0,
  },
  staticCell23: {
    width: "10%",
    borderRight: "1 solid black",
    borderTop: "1 solid black",
    textAlign: "right",
    paddingBottom: 5,
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 5,
  },
  staticCellText: {
    fontSize: 6
  },
});

PdfStockSingleDay.propTypes = {
  stocksProduct: PropTypes.object, // Les données du store
  selectedDate: PropTypes.string // date sélectionnée formattée
};

export default PdfStockSingleDay;
